import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './banner2.css';
import { Download } from 'lucide-react';

const VerticalSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const [direction, setDirection] = useState('up');
  
  const products = [
    {
      id: 1,
      image: '/assets/products-with-logo/paper-bags/paper-bags-large-size.jpg',
      title: 'Paper bags',
      bgColor: '#B08968',
      subtitle: 'Professional and reliable',
      heading: 'Premium Paper Bags',
      description: 'Eco-friendly paper bags crafted with premium materials, perfect for retail and promotional use. Sustainable solutions that make a lasting impression.',
      link: '/paper-bags',
      brochure: '/assets/brochures/broucher-1.pdf'
    },
    {
      id: 2,
      image: '/assets/products-with-logo/courier-bags/courier-bags-large-size.png',
      title: 'Courier Bags',
      bgColor: '#E6CCB2',
      subtitle: 'Secure and durable',
      heading: 'Courier Bags',
      description: 'High-strength courier bags designed for maximum protection during transit. Tamper-evident seals and water-resistant materials ensure your items arrive safely.',
      link: '/courier-bags',
      brochure: '/assets/brochures/broucher-1.pdf'
    },
    {
      id: 3,
      image: '/assets/products-with-logo/packaging-products/packaging-products-large-size.png',
      title: 'Packaging Products',
      bgColor: '#DDB892',
      subtitle: 'Professional and reliable',
      heading: 'Packaging Products',
      description: 'From secure courier bags to versatile paper solutions, our packaging products offer high-quality, eco-conscious options designed to protect and present your items with professional excellence.',
      link: '/packaging-products',
      brochure: '/assets/brochures/broucher-1.pdf'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 3000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const handlePrev = () => {
    setDirection('down');
    setIsAnimating(false);
    setTimeout(() => setIsAnimating(true), 50);
    setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setDirection('up');
    setIsAnimating(false);
    setTimeout(() => setIsAnimating(true), 50);
    setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="main-container" style={{ 
        background: products[currentIndex].bgColor, 
        backgroundSize: 'cover', 
        backgroundRepeat: 'no-repeat' 
    }}>
      <div className="container-fluid p-0 position-relative">
        <div className="nav-buttons">
          <button onClick={handlePrev} className="nav-btn">↑</button>
          <button onClick={handleNext} className="nav-btn">↓</button>
        </div>
        <div className="row g-0">
          <div className="col-md-6">
            <div className="content-banner-wrapper p-5 d-flex flex-column align-items-start justify-content-center w-75 mx-auto">
              <small className={`banner-product-sub-heading text-black text-uppercase letter-spacing-1 mb-2 d-block ${isAnimating ? 'slide-in' : ''}`}>
                {products[currentIndex].subtitle}
              </small>
              <h2 className={`banner-products-heading display-5 text-dark mb-4 ${isAnimating ? 'fade-up' : ''}`}>
                {products[currentIndex].heading}
              </h2>
              <p className={`product-banner-desc text-black mb-4 ${isAnimating ? 'slide-right' : ''}`}>
                {products[currentIndex].description}
              </p>
              <div className={`button-wrapper ${isAnimating ? 'fade-up-delay' : ''}`}>
                <a 
                  href={products[currentIndex].link}
                  className="explore-btn"
                >
                  Explore More
                </a>
                <a 
                  href={products[currentIndex].brochure}
                  className="explore-btn download-btn"
                >
                  <Download size={16} className="mr-2" />
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="slider-container">
              <div className={`slides-wrapper ${direction}`}>
                {products.map((product, index) => {
                  const isActive = index === currentIndex;
                  const isPrev = index === (currentIndex - 1 + products.length) % products.length;
                  const isNext = index === (currentIndex + 1) % products.length;
                  
                  return (
                    <div 
                      key={product.id} 
                      className={`slide-banner2 ${isActive ? 'active' : ''}`}
                      style={{
                        transform: `translateY(${isActive ? '0' : isPrev ? '-100%' : isNext ? '100%' : '0'}%)`,
                        opacity: isActive ? 1 : 0,
                        visibility: (isActive || isPrev || isNext) ? 'visible' : 'hidden',
                        zIndex: isActive ? 1 : 0
                      }}
                    >
                      <img 
                        src={product.image} 
                        alt={product.title} 
                        className={`product-img ${isAnimating && isActive ? 'scale-in' : ''}`}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerticalSlider;